export default {
    navigationBarTitleText: "项目成员",
  };
  